'use client';

import { useCTW } from '@ctw/shared/context/ctw-context';
import { Telemetry } from '@ctw/shared/context/telemetry';
import { type PropsWithChildren, useLayoutEffect } from 'react';

interface TelemetryProviderProps extends PropsWithChildren {}

export const TelemetryInitializer = ({ children }: TelemetryProviderProps) => {
  const { requestContext } = useCTW();

  // Initialize telemetry in the background. Events fired before initialization
  // completes are buffered in Telemetry.deferredEvents and replayed via
  // flushDeferredEvents() once init finishes — no events are lost.
  useLayoutEffect(() => {
    void Telemetry.init({
      requestContext,
    });
  }, [requestContext]);

  return children;
};
